import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { CONTACT_BOX_TECHNICAL_CONVERTER_TOKEN, ContactBoxTechnicalConverter } from './contact-box-technical.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        contactBoxTechnicalFeature: {
          module: () => import('./contact-box-technical.module').then((m) => m.ContactBoxTechnicalModule),
          cmsComponents: ['contactbox_technical_support'],
        },
      }
    }),
    {
      provide: CONTACT_BOX_TECHNICAL_CONVERTER_TOKEN,
      useExisting: ContactBoxTechnicalConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        contactbox_technical_support: CONTACT_BOX_TECHNICAL_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class ContactBoxTechnicalFeatureModule {}
